import ModelEntity, { ModelOptions } from "../model-entity"
import {EntityType} from "../../gd/const/item"
import ApiTeam from "../../gd/api/company/team"
import ModelProxy from "../model-proxy"

// const debug = "Team"
const debug = false

export default class Team extends ModelEntity {

    public name         : string
    private _userIds    : ID[]
    public description? : string
    public properties   : object

    constructor(data: any, options:ModelOptions={useProxy:true}) {
        super(data.id, EntityType.TEAM)

        this.name         = data.name || ''
        this._userIds     = data.userIds || []
        this.description  = data.description || undefined
        this.properties   = data.properties || {}

        return options.useProxy ? new Proxy(this, ModelProxy) : this
    }

    // No id = new ver saved = new model
    get isNewModel(): boolean {
        return !this.id || this.id === 'new'
    }

    get membersTotal(): number {
        return this._userIds.length
    }

    set userIds(value: ID[] | null) {
        this._userIds = value || []
    }

    get userIds(): ID[] {
        return this._userIds
    }

    goTo() {
        gd.navigation.goTo('o/team/'+this.id)
    }

    quickSearch(quickSearchValue: string): boolean {
        return this.name.toLowerCase().includes(quickSearchValue.toLowerCase())
    }

    toJSON() {
        return {
            name        : this.name,
            description : this.description,
            userIds     : this.userIds
        }
    }

    async save(): Promise<boolean> {
        const payload: any = {}

        debug && console.log(debug, "save", this.updatedFields);

        // if new model -> create instead of save
        if (this.isNewModel) {
            await ApiTeam.create(this).promise()
            return true
        }

        // Update
        // this is for universal update
        this.updatedFields.forEach((fieldName) => {
            switch (fieldName) {
                default:
                    // @ts-ignore
                    payload[fieldName] = this[fieldName]
            }
        })

        this.updatedFields.clear()

        if (_.size(payload) > 0) {
            await ApiTeam.update(this.id, payload).promise()
            return true
        }

        return false
    }
}